module.exports = __webpack_public_path__ + "img/orange-money-new.b2f0b0c4.png";